import React from 'react';
import NotificationBell from '../../../components/admin/NotificationBell';
import MessageNotificationBell from '../../../components/admin/MessageNotificationBell';

interface CalendarHeaderProps {
  onAddEventClick: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ onAddEventClick }) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <h1 className="text-2xl font-semibold text-gray-800">Scheduling</h1>
      <div className="flex items-center gap-3">
        <MessageNotificationBell />
        <NotificationBell />
        <button
          onClick={onAddEventClick}
          className="px-4 py-2 bg-[#4A5568] text-white rounded-md hover:bg-[#2D3748] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D3748]"
        >
          Add Event
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader; 